import { FontWeights } from '@fluentui/react';
import { FontSizes as FluentFontSizes } from '@uifabric/fluent-theme/lib/fluent/FluentType';
export var FontSizes;
(function (FontSizes) {
    FontSizes.size74 = '74px';
    FontSizes.size58 = '58px';
    FontSizes.size42 = FluentFontSizes.size42;
    FontSizes.size34 = '34px';
    FontSizes.size26 = '26px';
    FontSizes.size22 = '22px';
    FontSizes.size18 = FluentFontSizes.size18;
    FontSizes.size16 = FluentFontSizes.size16;
    FontSizes.size14 = FluentFontSizes.size14;
    FontSizes.size12 = FluentFontSizes.size12;
})(FontSizes || (FontSizes = {}));
export var DefaultTypography;
(function (DefaultTypography) {
    DefaultTypography.hero = {
        fontSize: FontSizes.size42,
        fontWeight: FontWeights.bold
    };
    DefaultTypography.header = {
        fontSize: FontSizes.size26,
        fontWeight: FontWeights.bold
    };
    DefaultTypography.subheader = {
        fontSize: FontSizes.size18,
        fontWeight: FontWeights.semibold
    };
    DefaultTypography.base = {
        fontSize: FontSizes.size14,
        fontWeight: FontWeights.semibold
    };
    DefaultTypography.body = {
        fontSize: FontSizes.size14,
        fontWeight: FontWeights.regular
    };
    DefaultTypography.caption = {
        fontSize: FontSizes.size12,
        fontWeight: FontWeights.regular
    };
})(DefaultTypography || (DefaultTypography = {}));
export var ExtendedTypography;
(function (ExtendedTypography) {
    ExtendedTypography.size74Regular = {
        fontSize: FontSizes.size74,
        fontWeight: FontWeights.regular
    };
    ExtendedTypography.size74Semibold = {
        fontSize: FontSizes.size74,
        fontWeight: FontWeights.semibold
    };
    ExtendedTypography.size74Bold = {
        fontSize: FontSizes.size74,
        fontWeight: FontWeights.bold
    };
    ExtendedTypography.size58Regular = {
        fontSize: FontSizes.size58,
        fontWeight: FontWeights.regular
    };
    ExtendedTypography.size58Semibold = {
        fontSize: FontSizes.size58,
        fontWeight: FontWeights.semibold
    };
    ExtendedTypography.size58Bold = {
        fontSize: FontSizes.size58,
        fontWeight: FontWeights.bold
    };
    ExtendedTypography.size42Regular = {
        fontSize: FontSizes.size42,
        fontWeight: FontWeights.regular
    };
    ExtendedTypography.size42Semibold = {
        fontSize: FontSizes.size42,
        fontWeight: FontWeights.semibold
    };
    ExtendedTypography.size42Bold = {
        fontSize: FontSizes.size42,
        fontWeight: FontWeights.bold
    };
    ExtendedTypography.size34Regular = {
        fontSize: FontSizes.size34,
        fontWeight: FontWeights.regular
    };
    ExtendedTypography.size34Semibold = {
        fontSize: FontSizes.size34,
        fontWeight: FontWeights.semibold
    };
    ExtendedTypography.size34Bold = {
        fontSize: FontSizes.size34,
        fontWeight: FontWeights.bold
    };
    ExtendedTypography.size26Regular = {
        fontSize: FontSizes.size26,
        fontWeight: FontWeights.regular
    };
    ExtendedTypography.size26Semibold = {
        fontSize: FontSizes.size26,
        fontWeight: FontWeights.semibold
    };
    ExtendedTypography.size26Bold = {
        fontSize: FontSizes.size26,
        fontWeight: FontWeights.bold
    };
    ExtendedTypography.size22Regular = {
        fontSize: FontSizes.size22,
        fontWeight: FontWeights.regular
    };
    ExtendedTypography.size22Semibold = {
        fontSize: FontSizes.size22,
        fontWeight: FontWeights.semibold
    };
    ExtendedTypography.size22Bold = {
        fontSize: FontSizes.size22,
        fontWeight: FontWeights.bold
    };
    ExtendedTypography.size18Regular = {
        fontSize: FontSizes.size18,
        fontWeight: FontWeights.regular
    };
    ExtendedTypography.size18Semibold = {
        fontSize: FontSizes.size18,
        fontWeight: FontWeights.semibold
    };
    ExtendedTypography.size18Bold = {
        fontSize: FontSizes.size18,
        fontWeight: FontWeights.bold
    };
    ExtendedTypography.size16Regular = {
        fontSize: FontSizes.size16,
        fontWeight: FontWeights.regular
    };
    ExtendedTypography.size16Semibold = {
        fontSize: FontSizes.size16,
        fontWeight: FontWeights.semibold
    };
    ExtendedTypography.size16Bold = {
        fontSize: FontSizes.size16,
        fontWeight: FontWeights.bold
    };
    ExtendedTypography.size14Regular = {
        fontSize: FontSizes.size14,
        fontWeight: FontWeights.regular
    };
    ExtendedTypography.size14Semibold = {
        fontSize: FontSizes.size14,
        fontWeight: FontWeights.semibold
    };
    ExtendedTypography.size14Bold = {
        fontSize: FontSizes.size14,
        fontWeight: FontWeights.bold
    };
    ExtendedTypography.size12Regular = {
        fontSize: FontSizes.size12,
        fontWeight: FontWeights.regular
    };
    ExtendedTypography.size12Semibold = {
        fontSize: FontSizes.size12,
        fontWeight: FontWeights.semibold
    };
    ExtendedTypography.size12Bold = {
        fontSize: FontSizes.size12,
        fontWeight: FontWeights.bold
    };
})(ExtendedTypography || (ExtendedTypography = {}));
//# sourceMappingURL=CoherenceTypography.js.map